import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IdleTimerProvider } from 'react-idle-timer';

const AutoLogout = () => {
    const [isIdle, setIsIdle] = useState(false);
    const navigate = useNavigate();
    const idleTimeout = 15 * 60 * 1000; // 15 minutes

    // Logout function
    const handleLogout = () => {
        console.log('Logging out due to inactivity or browser close.');
        localStorage.removeItem("token_master");
        localStorage.removeItem("company_id_master");
        localStorage.removeItem("user_id_master");
        navigate('/');
        window.location.reload();
    };
    useEffect(()=>{
        const now = Date.now();
        localStorage.setItem('lastActiveMaster', now);
        setIsIdle(false);
    },[]);
    // Function to reset idle timer and update last active timestamp
    const resetIdleTimer = () => {
        localStorage.setItem('lastActiveMaster', Date.now()); // Sync across tabs
        setIsIdle(false); // Reset idle state
    };

    // Sync the last active time across tabs using localStorage
    const syncLastActiveMaster = () => {
        const storedLastActiveMaster = localStorage.getItem('lastActiveMaster');
        if (storedLastActiveMaster) {
            resetIdleTimer(); // Reset idle state if activity is detected
        } else {
            console.warn('No lastActiveMaster found. Skipping sync for fresh session.');
        }
    };
    useEffect(() => {
        // On fresh load, initialize lastActiveMaster if missing
        const storedLastActiveMaster = localStorage.getItem('lastActiveMaster');
        if (!storedLastActiveMaster) {
            localStorage.setItem('lastActiveMaster', Date.now()); // Initialize
        }
    
        // Add event listener for cross-tab synchronization
        window.addEventListener('storage', syncLastActiveMaster);
    
        return () => {
            window.removeEventListener('storage', syncLastActiveMaster);
        };
    }, []);
    useEffect(() => {
        const token = localStorage.getItem('token_master');
        if (!token) {
            setIsIdle(true); // Trigger idle if no token exists
            return;
        }
    
        const now = Date.now();
        const storedLastActiveMaster = localStorage.getItem('lastActiveMaster');
    
        // Prevent immediate logout on fresh load
        if (!storedLastActiveMaster || now - storedLastActiveMaster < idleTimeout) {
            console.log('Session is active, preventing immediate logout.');
            resetIdleTimer();
        } else {
            setIsIdle(true);
        }
    }, []);
    
    useEffect(() => {
    const sessionKey = 'session_active_master';

    // Check and initialize session status
    if (!sessionStorage.getItem(sessionKey)) {
        sessionStorage.setItem(sessionKey, 'true'); // Set session as active
    }

    // Handle visibility changes for refresh scenarios
    const handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
            sessionStorage.setItem('refresh_flag_master', 'true');
        } else {
            sessionStorage.removeItem('refresh_flag_master');
        }
    };

    window.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
        window.removeEventListener('visibilitychange', handleVisibilityChange);
    };
}, []);



    // Fetch regularization settings and handle token expiration
    useEffect(() => {
        const sessionKey = 'session_active_master';
    
        // Check and initialize session status
        if (!sessionStorage.getItem(sessionKey)) {
            sessionStorage.setItem(sessionKey, 'true'); // Set session as active
        }
    
        // Handle visibility changes for refresh scenarios
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                sessionStorage.setItem('refresh_flag_master', 'true');
            } else {
                sessionStorage.removeItem('refresh_flag_master');
            }
        };
    
        window.addEventListener('visibilitychange', handleVisibilityChange);
    
        return () => {
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    // const getRegularizationSettings = () => {
    //     const headers = apiHeaderJson;
    //     axios
    //         .get(`${apiURL}Attendance/GetRegularizationSettings`, { headers })
    //         .then(response => {
    //             const { success, message } = response.data;
    //             if (success === false && message === 'This token has been expired.') {
    //                 console.log('Token has expired, triggering idle state.');
    //                 setIsIdle(true); // Treat expired token as idle
    //             }
    //         })
    //         .catch(error => {
    //             console.error('Error fetching regularization settings:', error);
    //         });
    // };

    useEffect(() => {
        if (isIdle) {
            handleLogout();
        }
    }, [isIdle]);

    // useEffect(() => {
    //     getRegularizationSettings();
    // }, []);

    return (
        <IdleTimerProvider
            timeout={idleTimeout}
            onIdle={() => setIsIdle(true)}
            onActive={resetIdleTimer}
            debounce={500} 
        >
            {null}
        </IdleTimerProvider>
    );
};

export default AutoLogout;